// The roster's online edges (#3629 C), moved out of app.svelte.ts: the edge clock, what each
// read covered, and the edges parked or failed until a read can take them.
import { accountSync } from "../plugins/agents/sync-session.js";

// Every roster read goes through here. The relay only asks daemons connected when the
// read arrives, so a daemon whose online edge came later is carried, not dropped, and read
// again on its own (a desktop cold start boots its daemon after the renderer's first read).
// Never rewound: a read issued before a reset must not match an edge after it.
export let rosterEdgeSeq = 0;
export const daemonOnlineEdge = accountSync.collection(
  "daemonOnlineEdge",
  new Map<string, number>(),
);
// Newest read issued per daemon ("*" = unscoped): an edge at or before it is already covered.
export const rosterReadSeq = accountSync.collection("rosterReadSeq", new Map<string, number>());
export const coveredSeq = (id: string) =>
  Math.max(rosterReadSeq.get(id) ?? -1, rosterReadSeq.get("*") ?? -1);
// Online edges that landed while no workspace was committed; re-read at the commit.
export const bootOnlineDaemons = accountSync.collection("bootOnlineDaemons", new Set<string>());
// Daemon re-reads that failed; each is retried once on the next reconnect/notice.
export const failedRereads = accountSync.collection("failedRereads", new Map<string, string>());
// Workspaces each daemon's status copies named; a read outside them is refused cross-tenant.
export const daemonEdgeWorkspaces = accountSync.collection(
  "daemonEdgeWorkspaces",
  new Map<string, Set<string>>(),
);
export const daemonOutsideWorkspace = (daemonId: string, wsId: string) => {
  const named = daemonEdgeWorkspaces.get(daemonId);
  return !!named && !named.has(wsId); // ponytail: unknown (older relay) reads as inside
};

// The clock only moves forward: an import cannot assign it, so the edge is taken here.
export function nextRosterEdge(): number {
  rosterEdgeSeq += 1;
  return rosterEdgeSeq;
}
